var React = require('react');

function NeoskopSignet (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M14.4912 0.411412V15.9588L0.122807 0H0V14.1088L3.19298 17.6619V8.01247L17.5614 24H17.6842V0.411412H14.4912Z"}));
}

NeoskopSignet.defaultProps = {"viewBox":"0 0 18 24"};

module.exports = NeoskopSignet;

NeoskopSignet.default = NeoskopSignet;
